import React from "react";
import {Button, Modal} from "react-bootstrap";
/*
 * A modal dialog pop-up showing the successful excel file upload results.
 * Results also shows InComm shop ordering requirements if the gift cards must
 * be ordered through the shop
 * @param show - Boolean state indicating if the modal should be displayed
 * @param {message}  - message result contents from the backend.
**/

const UploadStatus = ({show, closeDialog, message}) => {
  return (
      <>
        <Modal show={show} onHide={closeDialog} closebutton id="loadSuccessMessage" backdrop="static" keyboard={false}>
          <Modal.Header>
            <span className="close" onClick={closeDialog}>&times;</span>
            <div>SUCCESS</div>
          </Modal.Header>
          <Modal.Body>
            <div dangerouslySetInnerHTML={{__html: message}}></div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="gcotg-button" onClick={closeDialog}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
  );
};

export default UploadStatus;
